import {
  type PosDevicePaymentTerminal,
  toPosDevicePaymentTerminal,
} from "~/lib/validators/pos-device-payment-terminal";

const POS_DEVICE_TERMINAL_CONFIG_STORAGE_KEY_PREFIX = "terminal-config-";

export const getPosDeviceTerminalConfigStorageKey = (deviceId: string) => {
  return `${POS_DEVICE_TERMINAL_CONFIG_STORAGE_KEY_PREFIX}${deviceId}`;
};

export const readPendingPosDeviceTerminalConfig = (
  deviceId: string
): PosDevicePaymentTerminal | null => {
  const rawValue = sessionStorage.getItem(
    getPosDeviceTerminalConfigStorageKey(deviceId)
  );

  if (!rawValue) {
    return null;
  }

  try {
    return toPosDevicePaymentTerminal(JSON.parse(rawValue));
  } catch {
    return null;
  }
};

export const writePendingPosDeviceTerminalConfig = (
  deviceId: string,
  paymentTerminal: PosDevicePaymentTerminal
) => {
  sessionStorage.setItem(
    getPosDeviceTerminalConfigStorageKey(deviceId),
    JSON.stringify(toPosDevicePaymentTerminal(paymentTerminal))
  );
};

export const clearPendingPosDeviceTerminalConfig = (deviceId: string) => {
  sessionStorage.removeItem(getPosDeviceTerminalConfigStorageKey(deviceId));
};
